export enum ToolboxStateEnum {
  Home = 'HOME',
  SalaryContributions = 'SALARY_CONTRIBUTIONS',
}